import { formatRelativeTime } from '@/lib/datetime';

/** "Last seen 5 minutes ago" from an ISO time; "Offline" when unknown. */
export function lastSeenLabel(iso: string | null, now: number = Date.now()): string {
  const ago = formatRelativeTime(iso, now);
  return ago ? `Last seen ${ago}` : 'Offline';
}
